export const LOAD_QUESTION_FEEDBACK_REQUEST = 'QuestionFeedbackPage/LOAD_QUESTION_FEEDBACK_REQUEST';
export const LOAD_QUESTION_FEEDBACK_SUCCESS = 'QuestionFeedbackPage/LOAD_QUESTION_FEEDBACK_SUCCESS';
export const LOAD_QUESTION_FEEDBACK_FAILURE = 'QuestionFeedbackPage/LOAD_QUESTION_FEEDBACK_FAILURE';
export const UPDATE_QUESTION_FEEDBACK_REQUEST = 'QuestionFeedbackPage/UPDATE_QUESTION_FEEDBACK_REQUEST';
export const UPDATE_QUESTION_FEEDBACK_SUCCESS = 'QuestionFeedbackPage/UPDATE_QUESTION_FEEDBACK_SUCCESS';
export const UPDATE_QUESTION_FEEDBACK_FAILURE = 'QuestionFeedbackPage/UPDATE_QUESTION_FEEDBACK_FAILURE';
